<template>
    <div class="disclaimer">
        <h5 v-if="title">{{ title }}</h5>
        <a v-if="link" :href="link?.value" target="_blank">{{ link?.name }}</a>
        <slot>
            <p>{{
                locale == 'en'
                    ? 'If you have any information about adverse drug reactions or special circumstances at Sandoz and Novartis Pharmaceuticals, please send this information to your email address adverse.event.uzbekistan@sandoz.com Or call 998 (78) 147 03 35'
                    : 'Если у вас есть информация о нежелательных реакциях или особых ситуациях, связанных с приемом препаратов компании группы Новартис (Новартис Фарма и Сандоз), просьба, передать эту информацию на электронный почтовый ящик drugsafety.cis@novartis.com или по телефону +99878 147 03 35'
            }}</p>
            <p>{{ $t('disclaimer.1') }}</p>
        </slot>
    </div>
</template>

<script setup>
import { useI18n, defineProps, defineOptions } from 'vue-i18n';

defineOptions({
	name: 'BaseDisclaimer',
})

const { locale } = useI18n();

defineProps({
    link: {
        type: Object,
        required: false,
        default: undefined
    },
    title: {
        type: String,
        required: true
    }
})

</script>

<style lang="scss">

.disclaimer {
    padding: 32px;
    border-radius: 16px;
    background: #F9F8FF;
    display: flex;
    flex-direction: column;
    gap: 10px;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: #413663;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px; /* 140% */
    }
    p, a {
        font-size: 16px;
        line-height: 24px;
    }
    a {
        color: #00aea0;
        text-decoration: underline;
    }
    p {
        color: #413663;
    }
}

</style>
